import { gql } from '@apollo/client'

export const GET_APPLICANT_FILTER_PRESETS = gql`
  query GetApplicantFilterPresets(
    $employeeId: String!
    $pageInfo: PageInfoInput
  ) {
    applicantFilterPresets(employeeId: $employeeId, pageInfo: $pageInfo) {
      totalCount
      items {
        applicantFilterPresetId
        name
        order
        filters
        pageSize
        columns {
          column
          order
          customFieldId
          stepType
          customStepId
        }
        sortBy {
          sortBy
          direction
          order
          customFieldId
        }
        createdAt
        updatedAt
        employee {
          employeeId
          firstName
          lastName
        }
      }
    }
  }
`

export const CREATE_APPLICANT_FILTER_PRESET = gql`
  mutation CreateApplicantFilterPreset(
    $input: CreateApplicantFilterPresetInput!
  ) {
    createApplicantFilterPreset(input: $input) {
      applicantFilterPresetId
      name
      filters
      pageSize
      columns {
        column
        order
        customFieldId
        stepType
        customStepId
      }
      sortBy {
        sortBy
        direction
        order
        customFieldId
      }
      createdAt
      updatedAt
      employee {
        employeeId
        firstName
        lastName
      }
    }
  }
`
export const UPDATE_APPLICANT_FILTER_PRESET = gql`
  mutation UpdateApplicantFilterPreset(
    $applicantFilterPresetId: String!
    $input: UpdateApplicantFilterPresetInput!
  ) {
    updateApplicantFilterPreset(
      applicantFilterPresetId: $applicantFilterPresetId
      input: $input
    ) {
      applicantFilterPresetId
      name
      filters
      pageSize
      columns {
        column
        order
        customFieldId
        stepType
        customStepId
      }
      sortBy {
        sortBy
        direction
        order
        customFieldId
      }
      createdAt
      updatedAt
    }
  }
`

export const DELETE_APPLICANT_FILTER_PRESET = gql`
  mutation DeleteApplicantFilterPreset($applicantFilterPresetId: String!) {
    deleteApplicantFilterPreset(
      applicantFilterPresetId: $applicantFilterPresetId
    )
  }
`

export const REORDER_APPLICANT_FILTER_PRESETS = gql`
  mutation ReorderApplicantFilterPresets($presetIds: [String!]!) {
    reorderApplicantFilterPresets(presetIds: $presetIds) {
      applicantFilterPresetId
      name
      order
      filters
      pageSize
      columns {
        column
        order
        customFieldId
        stepType
        customStepId
      }
      sortBy {
        sortBy
        direction
        order
        customFieldId
      }
    }
  }
`

export const SHARE_APPLICANT_FILTER_PRESET = gql`
  mutation ShareApplicantFilterPreset(
    $applicantFilterPresetId: String!
    $employeeIds: [String!]!
  ) {
    shareApplicantFilterPreset(
      applicantFilterPresetId: $applicantFilterPresetId
      employeeIds: $employeeIds
    ) {
      applicantFilterPresetId
      name
      filters
      pageSize
      columns {
        column
        order
        customFieldId
        stepType
        customStepId
      }
      sortBy {
        sortBy
        direction
        order
        customFieldId
      }
      createdAt
      updatedAt
      employee {
        employeeId
        firstName
        lastName
      }
    }
  }
`
